<div class="ack">
  <div class="ack__header">
    <mat-icon svgIcon="warning" class="ack__glyph"></mat-icon>
    <div class="ack__eyebrow">{{ 'SOS.SEVERITY' | translate }}</div>
    <div class="ack__title">{{ 'SOS.ACK_DIALOG_TITLE' | translate }}</div>
  </div>

  <div class="ack__body">
    <div class="ack__summary">
      <div class="ack__field">
        <span class="ack__label">{{ 'SOS.DRIVER' | translate }}</span>
        <span class="ack__value">{{ alert.driver }}</span>
      </div>
      <div class="ack__field">
        <span class="ack__label">{{ 'SOS.VEHICLE' | translate }}</span>
        <span class="ack__value">{{ alert.vehicle }}</span>
      </div>
      <div class="ack__field">
        <span class="ack__label">{{ 'SOS.LOCATION' | translate }}</span>
        <span class="ack__value">{{ alert.location }}</span>
      </div>
      <div class="ack__field">
        <span class="ack__label">{{ 'SOS.TIME' | translate }}</span>
        <span class="ack__value">{{ alert.occurrenceTime | dayjsDateTime }}</span>
      </div>
    </div>

    <label class="ack__note-label" for="sosAckNote">{{ 'SOS.NOTE_LABEL' | translate }}</label>
    <textarea #note id="sosAckNote" class="ack__note" rows="3" [placeholder]="'SOS.NOTE_PLACEHOLDER' | translate"></textarea>
  </div>

  <div class="ack__footer">
    <button type="button" class="ack__btn ack__btn--ghost" (click)="cancel()">{{ 'SOS.CANCEL' | translate }}</button>
    <button type="button" class="ack__btn ack__btn--confirm" (click)="confirm(note.value)">
      <mat-icon svgIcon="check_circle"></mat-icon>
      <span>{{ 'SOS.CONFIRM_ACK' | translate }}</span>
    </button>
  </div>
</div>
